import { useEffect, useState } from "react";
import { FaReact, FaNodeJs, FaGithub, FaServer, FaDownload, FaArrowRight } from "react-icons/fa";

import { SiMongodb } from "react-icons/si";

import { motion } from "framer-motion";

import "./Hero.css";

const roles = ["Full-Stack Developer", "QA Engineer", "System Administrator", "IT Engineer"];

export default function Hero() {
  const [roleIndex, setRoleIndex] = useState(0);
  const [pointer, setPointer] = useState({ x: 0, y: 0 });
  const [tilt, setTilt] = useState({ rotateX: 0, rotateY: 0 });

  useEffect(() => {
    const interval = setInterval(() => {
      setRoleIndex((prev) => (prev + 1) % roles.length);
    }, 2200);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const onMove = (event) => {
      setPointer({ x: event.clientX, y: event.clientY });
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  const techBadges = [
    { name: "React", icon: FaReact, position: "left-[4%] top-[6%] sm:left-[8%] sm:top-[6%]" },
    { name: "Docker", icon: FaServer, position: "right-[4%] top-[8%] sm:right-[8%] sm:top-[8%]" },
    { name: "MongoDB", icon: SiMongodb, position: "left-[2%] top-[44%] sm:left-[4%] sm:top-[44%]" },
    { name: "Linux", icon: FaServer, position: "right-[2%] top-[44%] sm:right-[4%] sm:top-[44%]" },
    { name: "Git", icon: FaGithub, position: "left-[10%] bottom-[8%] sm:left-[12%] sm:bottom-[8%]" },
    { name: "Node", icon: FaNodeJs, position: "right-[8%] bottom-[8%] sm:right-[10%] sm:bottom-[8%]" },
  ];

  const handleTilt = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;

    setTilt({ rotateX: y * -6, rotateY: x * 6 });
  };

  const resetTilt = () => setTilt({ rotateX: 0, rotateY: 0 });

  return (
    <section className="relative overflow-hidden px-4 py-24 text-white sm:px-6 lg:px-8 lg:py-32 animated-bg">
      <div
        className="pointer-events-none absolute inset-0 z-0 transition-opacity duration-300"
        style={{
          background: `radial-gradient(320px circle at ${pointer.x}px ${pointer.y}px, rgba(42, 182, 0, 0.14), transparent 65%)`,
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="relative z-10 mx-auto flex max-w-7xl flex-col gap-16 lg:gap-20"
      >
        <div className="grid items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="max-w-3xl">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-sm text-white/70 backdrop-blur-sm">
              <span className="h-2.5 w-2.5 rounded-full bg-accent" />
              Freelancing & Open to Work
            </div>

            <h1 className="font-display text-4xl font-semibold leading-[0.9] text-white sm:text-5xl lg:text-7xl">
              Hi, I’m Kushal Neupane.
            </h1>

            <div className="mt-4 flex min-h-[2.8rem] items-center text-lg text-white/70 sm:text-xl">
              <span className="mr-2 text-accent">/</span>
              {/* <span className="font-mono text-sm uppercase tracking-[0.2em] text-white/60">Working as</span> */}
              <span className="ml-3 font-semibold text-white">{roles[roleIndex]}</span>
            </div>

            <p className="mt-6 max-w-2xl text-base leading-8 text-white/70 sm:text-lg">
             IT Engineer experienced in System Administration, Full-Stack Development, and Software Quality Assurance, delivering secure, scalable, and efficient solutions with a strong focus on performance and reliability.
              </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="/resume.pdf"
                download
                className="inline-flex items-center justify-center gap-2 rounded-full border border-accent/30 bg-accent/10 px-5 py-3 text-sm font-semibold text-accent transition hover:bg-accent hover:text-black"
              >
                <FaDownload />
                Download Resume
              </a>
              <a
                href="/contact"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-3 text-sm font-semibold text-white/90 transition hover:border-white/20 hover:bg-white/10"
              >
                Contact Me
                <FaArrowRight />
              </a>
            </div>
          </div>

          <div className="relative mx-auto flex w-full max-w-[520px] items-center justify-center lg:justify-end">
            <div className="absolute inset-0 rounded-full bg-[radial-gradient(circle,_rgba(42,182,0,0.28),_transparent_70%)] blur-3xl" />
            <div className="absolute inset-4 rounded-[2rem] border border-white/10 bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.08),_transparent_60%)]" />
            <div className="pointer-events-none absolute inset-4 rounded-[2rem] border border-dashed border-white/10" />

            <motion.div
              initial={{ opacity: 0, x: 50, scale: 0.95 }}
              animate={{
                opacity: 1,
                x: 0,
                scale: 1,
                y: [0, -10, 0],
                rotate: [0, 1, 0, -1, 0],
              }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              whileHover={{ scale: 1.03, rotate: 1 }}
              onMouseMove={handleTilt}
              onMouseLeave={resetTilt}
              className="relative"
              style={{ transformStyle: "preserve-3d" }}
            >
              <motion.div
                animate={{ rotateX: tilt.rotateX, rotateY: tilt.rotateY }}
                transition={{ type: "spring", stiffness: 90, damping: 16 }}
                className="relative overflow-hidden rounded-[32px] border border-white/10 bg-[rgba(255,255,255,0.04)] p-3 shadow-[0_30px_80px_rgba(0,0,0,0.35)] backdrop-blur-xl sm:p-4"
              >
                <div className="absolute inset-0 rounded-[32px] border border-white/10" />
                <div className="relative overflow-hidden rounded-[24px] border border-white/10 bg-[#060606] p-2 sm:p-3">
                  <img
                    src="/avatar.png"
                    alt="Portrait of Kushal Neupane, IT Engineer and Full Stack Developer"
                    loading="eager"
                    decoding="async"
                    className="h-[280px] w-full object-contain sm:h-[360px] lg:h-[460px]"
                  />
                </div>
              </motion.div>

              {techBadges.map(({ name, icon: Icon, position }) => (
                <motion.div
                  key={name}
                  animate={{ y: [0, -8, 0], opacity: [0.9, 1, 0.9] }}
                  transition={{ duration: 3.6, repeat: Infinity, ease: "easeInOut" }}
                  className={`absolute ${position} rounded-full border border-white/10 bg-[rgba(255,255,255,0.06)] px-3 py-2 text-[11px] font-medium uppercase tracking-[0.24em] text-black/80 shadow-lg backdrop-blur-md`}
                >
                  <span className="mr-2 inline-flex items-center text-accent">
                    <Icon size={12} />
                  </span>
                  {name}
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>

        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {[
            
  { label: "Experience", value: "3+ Years" },
  { label: "Specialization", value: "React • Node • Linux" },
  { label: "Tech Stack", value: "MERN • Linux • Docker" },
  { label: "Status", value: "Open to Opportunities" },

          ].map((item) => (
            <div key={item.label} className="rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.24em] text-white/40">{item.label}</div>
              <div className="mt-2 text-lg font-semibold text-white">{item.value}</div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
